import styled, { css } from 'styled-components';

import { Box } from 'components/Box';
import { LegacyButton as Button } from 'components/Button/LegacyButton';
import { colors, cssBreakpoints, mediaRetina, transition } from 'theme/theme';

export const AspectRatioSvg = styled.svg`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;

  rect {
    fill: ${colors.inputGrey};
    stroke: ${colors.elementGrey};
    stroke-width: 1px;
    stroke-dasharray: 9px 7px;
    rx: 5px;
    transition: all ${transition};
    transition-property: stroke, fill;
  }
`;

export const DeleteButton = styled(Button)<{ $large?: boolean }>`
  transition: all ${transition};
  color: ${colors.lightContentGrey};
  &:hover,
  &:focus {
    color: ${colors.brandBlue};
  }
  ${(props) =>
    props.$large &&
    `
  width: 20px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  box-shadow: 0 0 0 2px transparent inset;
  &:hover {
    color: ${colors.alertRed};
    box-shadow: 0 0 0 2px ${colors.alertRed} inset;
  } 
  `}
`;

export const DropBox = styled(Box)<{ $hasFile?: boolean; $large?: boolean }>`
  color: ${(props) =>
    props.$hasFile || props.$large
      ? colors.lightContentGrey
      : colors.brandBlue};
  transition: all ${transition};
  & > * {
    position: relative;
    ${(props) =>
      props.$large
        ? ''
        : `
    border: 1px solid ${props.$hasFile ? colors.elementGrey : colors.brandBlue};
    ${mediaRetina} {
      border-width: 1.5px;
    }
    `}
    border-radius: 8px;
    transition: all ${transition};
  }
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 6px;
    opacity: 0;
    transition: all ${transition};
  }
`;

export const DropContainer = styled(Box)<{
  $mouseActive?: boolean;
  $large?: boolean;
  $dragActive?: boolean;
}>`
  &,
  * {
    pointer-events: none;
  }
  ${DeleteButton}, a {
    pointer-events: auto;
  }
  ${(props) =>
    props.$mouseActive
      ? css`
          ${DropBox} {
            & > * {
              border-color: ${colors.brandBlue};
              ${props.$large
                ? `
          color: ${colors.brandBlue};
          `
                : `
          background: ${colors.brandBlue};
          color: white;
          `}
            }
            &::before {
              opacity: 1;
            }
          }
          ${AspectRatioSvg} {
            rect {
              stroke: ${colors.brandBlue};
              fill: transparent;
            }
          }
        `
      : undefined}
  ${(props) =>
    props.$dragActive
      ? `
    * {
      pointer-events: none !important;
    }
  `
      : undefined}
`;

export const FileLink = styled.a<{ $large?: boolean }>`
  ${(props) =>
    props.$large &&
    `
  color: ${colors.mediumContentGrey};
  `}
`;

export const FilenameText = styled.div<{ $large?: boolean }>`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  vertical-align: middle;
  ${(props) =>
    props.$large
      ? `
    max-width: 300px;
    @media all and (min-width: ${cssBreakpoints.xsUp}) {
      max-width: none;
      overflow: visible;
      white-space: normal;
      text-overflow: clip;
    }
  `
      : `
    max-width: 200px;
  `}
`;
